let httpConfig = {
  COLA: 'https://sunflower-pt.coca-cola.cn',
  COLAHOST: 'https://sunflower.coca-cola.cn/'
}
// process.env.ENV_CONFIG !== 'test'

// 本地及测试环境使用
if (process.env.ENV_CONFIG === 'dev') {
  httpConfig = {
    // 接口地址
    COLA: 'http://qt-test.etrip.life',
    COLAHOST: 'https://newsgp-dev-web01.chinacloudsites.cn/'
  }
} else if (process.env.ENV_CONFIG === 'test') {
  httpConfig = {
    // 接口地址
    COLA: 'https://qt-test.etrip.life',
    COLAHOST: 'https://newsgp-dev-web01.chinacloudsites.cn/'
  }
} else if (process.env.ENV_CONFIG === 'pro') {
  httpConfig = {
    // 接口地址
    COLA: 'https://sunflower-pt.coca-cola.cn',
    COLAHOST: 'https://sunflower.coca-cola.cn/'
  }
}
export { httpConfig }

export const errorCode = {
  SUCCESS: 0,
  UNKNOWN: 1,
  FAILED: 2,
  UPGRADING: 3,
  SERVER_TOO_BUSY: 4,
  NOT_IMPLEMENTED: 5,
  IN_BLACKLIST: 6,
  SIGN_ERROR: 7,
  REQUEST_TOO_OFTEN: 9,
  PERMISSION_DENIED: 10,
  PARAM_NOT_ENOUGH: 11,
  PARAM_ERROR: 12,
  NOT_FOUND: 13,
  NOT_LOGIN: 14,
  USER_DEACTIVE: 15,
  WEIXIN_NOT_LOGIN: 16,
  SUPERUSER_PERMISSION_DENIED: 17,
  ACCOUNT_INVALID_CAPTCHA: 10004,
  INVALID_PASSWORD: 30001,
  HAD_USED: 30002,
  INVALID_CODE: 30003,
  INVALID_CAPTCHA: 10003,
  SEND_VERIFICATION_OVER_RATE: 10001,
  NOT_AUDIT: 30006,
  NOT_REGISTER_MOBILE: 30007,
  PAY_FAILED: 45007,
  PRODUCT_ID_ERROR: 46010,
  AMOUNT_ERROR: 46013,
  COUPON_UPLOAD_ERROR: 46017,
  COUPON_USED: 46019,
  PRIZE_IS_USED: 54006,
  PRIZE_TOO_LITTLE: 54012,
  PRIZE_RATE_ERROR: 54013,
  MONEY_NOT_ENOUGH: 54009,
  ACTIVITY_IS_PUBLISH: 54017,
  NOT_HAVE_AD: 54032,
  ORDINARY_USER: 30015,
  USER_END: 30022,
  ZERO_PAY: 30025,
  WX_AUTHORIZE: 30029,
  AMOUNT_NOT_ENOUGH: 54056,
  MANY_TIMES_LOGIN: 30030
};
// 可乐一级品类 二级品类下拉框
export const firstLevelList = [
  {
    value: 22,
    label: '提手',
  },
  {
    value: 26,
    label: '冰桶'
  },
  {
    value: 19,
    label: '塑料/亚克力工具类'
  }
]
export const secondLevelList = [
  {
    value: 2201,
    label: '普通提手'
  },
  {
    value: 2601,
    label: '塑料冰桶'
  },
  {
    value: 1902,
    label: '台卡'
  },
  {
    value: 1906,
    label: 'RB瓶箱挂板'
  },
  {
    value: 1913,
    label: '牙签筒'
  },
  {
    value: 1914,
    label: '筷子筒'
  }
]
// 可乐su状态
export const checkStatusList = [
  {
    value: 1,
    label: '待申请'
  },
  {
    value: 2,
    label: '草稿'
  },
  {
    value: 3,
    label: '待审核'
  },
  {
    value: 4,
    label: '通过'
  }
]
export const detectionStatusList = [
  {
    value: "",
    label: '全部'
  },
  {
    value: 1,
    label: '待审核'
  },
  {
    value: 11,
    label: '审核退回'
  },
  {
    value: 13,
    label: '修改信息待确认'
  },
  // {
  //   value: 14,
  //   label: '样品待寄出'
  // },
  // {
  //   value: 12,
  //   label: '待复审'
  // },
  // {
  //   value: 2,
  //   label: '复审修改信息待确认'
  // },
  {
    value: 4,
    label: '报价待确认'
  },
  {
    value: 15,
    label: '报价退回'
  },
  {
    value: 5,
    label: '待检测'
  },
  {
    value: 6,
    label: '检测中'
  },
  {
    value: 7,
    label: '报告待复核'
  },
  {
    value: 8,
    label: '检测完成'
  },
  {
    value: 9,
    label: '报告复核退回'
  },
  {
    value: 10,
    label: '流程关闭'
  }
]
// 供应商信息
export const supplyerMsg = [
  { name: '供应商名称', value: '', key: 'su_company_name'},
  { name: '联系人', value: '', key: 'su_contact_name'},
  { name: '联系电话', value: '', key: 'su_mobile'},
  { name: '联系邮箱', value: '', key: 'su_mail' },
]
// 产品信息
export const productMsg = [
  { name: '申请编号', value: '', key: 'sku_num' },
  { name: '产品类别', value: '', key: 'level_one_name > level_two_name'  },
  { name: '产品型号', value: '', key: 'product_model' },
  { name: '产品材质', value: '', key: 'material' },
  { name: '产品规格', value: '', key: 'size' },
  { name: '产品颜色', value: '', key: 'color' },
  { name: '产品重量（单位：克）', value: '', key: 'weight' },
  { name: '可口可乐核心要求', value: '', key: 'requirements' },
  { name: '产品描述', value: '', key: 'product_desc' }
]
// 样品信息
export const sampleMsg = [
  {name: '样品要求数量', value: '', key: 'necessary_sample_num'},
  {name: '样品质检周期', value: '', key: 'sample_quality_cycle'}
]
// 消费者年龄
export const consumerAge = ['婴儿', '未成年人', '成年人']
// 报告类型
export const reportTypeList = ['电子版中文报告','电子版英文报告','纸质版中文报告','纸质版英文报告','报告需附图片']
// 常规测试项目 物理测试项目
export const test_program = [
  {
    name: '常规测试项目',
    list: []
  },
  {
    name: '物理测试项目',
    list: []
  }
]



// WEBPACK FOOTER //
// ./src/api/api.js